import React, { useState, useEffect } from "react";

import HttpAction from "modules/utils/HttpAction";

const UserContext = React.createContext({
  state: { userInfo: {} },
  actions: {
    getUserInfo: () => {},
    logOut: () => {},
  },
});
const { Provider } = UserContext;

const UserProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({
    loggedIn: false, 
    userId: "", 
    userName: "", 
    userEmail: "",
    roleCode: "" 
  });
  const [menuList, setMenuList] = useState([])
  const getUserInfo = () => {
    HttpAction({
      url: "api/login",
      method: "get",
      fileused: false,
    }).then((res) => {
      if (res.code === 200) {
        updateUserData('login', res.data);
      } else {
        updateUserData('logout', '');
      }
    });
  };

  const updateUserData = (act, data) => {
    if(act == "login"){
      setUserInfo({
        loggedIn: true, 
        userId: data.userId, 
        userName: data.userName, 
        userEmail: data.email, 
        roleCode: data.roleCode 
      });
    }else{
      setUserInfo({
        loggedIn: false, 
        userId: "", 
        userName: "", 
        userEmail: "", 
        roleCode: "" 
      });
    }
  }

  const logout = () => {
    updateUserData('logout', '');
    localStorage.removeItem("jwt");
    window.location.href = `${process.env.REACT_APP_LANGUAGE}/login`;
  };

  const FindId = (userInfo) => {
    HttpAction({
      url: "api/login/idsearch",
      method: "post",
      data: {
        email: userInfo.email,
        userName: userInfo.userName,
      },
    }).then((res) => {
      if (res.code === 200) {
        alert("이메일 주소로 아이디 전송되었습니다.");
      } else if (res.code === 301) {
        alert("입력하신 이름과 이메일 주소가 일치하지 않습니다.");
      }
    });
  };

  const FindPassword = (userInfo) => {
    HttpAction({
      url: "api/login/pwsearch",
      method: "post",
      data: {
        email: userInfo.email,
        mobile: userInfo.mobile,
      },
    }).then((res) => {
      if (res.code === 200) {
        alert("이메일 주소로 비밀번호가 전송되었습니다.");
      } else if (res.code === 301) {
        alert("입력하신 이메일 주소와 휴대폰 번호가 일치하지 않습니다.");
      }
    });
  };

  const getMenuList = () => {
    HttpAction({
      url: "api/admin/menu-connect/list",
      method: "get",
      fileused: false,
    }).then((res) => {
      if (res.code === 200) {
        setMenuList(res.data)
      } else {
      }
    });
  };

  const updatePassword = (password,setModal) => {
    HttpAction({
      url: "api/admin/user/password",
      method: "post",
      data: {
        password: password,
      },
    }).then((res) => {
      if (res.code === 200) {
        if(!alert("비밀번호가 업데이트 되었습니다.")) setModal();
      } 
      else if( res.code==102)
        alert("패스워드를 입력하세요")
    });
  };

  useEffect(()=>{
    if (userInfo.loggedIn)
      getMenuList()
  },[userInfo])

  

  const value = {
    state: { userInfo, menuList },
    actions: { getUserInfo, logout, FindId, FindPassword, getMenuList, updatePassword },
  };

  return <Provider value={value}>{children}</Provider>;
};

export { UserContext, UserProvider };
